// extracted by mini-css-extract-plugin
module.exports = {"NotificationListWrapper":"PageLayout__NotificationListWrapper__mkgPJ","headerStaffBtn":"PageLayout__headerStaffBtn__DJ1IX","footerWrap":"PageLayout__footerWrap__2YlTp"};